import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getData } from "../../api/ApiRest";
import { Breadcrumb, Button, FloatingLabel, Form } from "react-bootstrap";
import LoadingComponent from "../../widgets/LoadingComponent";
import AsyncSelect from 'react-select/async';
import { FaSearch } from "react-icons/fa";
import {
    Chart as ChartJS,
    ArcElement,
    BarElement,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {
    Grid, Paper, TableContainer, Typography,
    Table, TableRow, TableCell, TableBody
} from "@mui/material";
import { formatNumber } from "../../widgets/FormatNumber";
import { FaFileExcel } from "react-icons/fa6";
import { exportToExcel } from "react-json-to-excel";

ChartJS.register(
    ArcElement, BarElement, Tooltip, Legend
);

function EmisionDocumentos() {
    const adminTae = useSelector((state) => state.auth.AdminTae);
    const companyId = useSelector((state) => state.auth.CompanyId);

    const [loading, setLoading] = useState(false);
    const [registros, setRegistros] = useState([]);
    const [dataBuscar, setDataBuscar] = useState({});

    const [registrosDiarios, setRegistrosDiarios] = useState([]);
    const [year, setYear] = useState([]);

    const labels = [...new Set(registros.filter(x => x.categoria !== 'Facturas').map(c => c.categoria))];

    ///Array de meses
    const mes = [
        { nombre: "Enero", valor: 1 },
        { nombre: "Febrero", valor: 2 },
        { nombre: "Marzo", valor: 3 },
        { nombre: "Abril", valor: 4 },
        { nombre: "Mayo", valor: 5 },
        { nombre: "Junio", valor: 6 },
        { nombre: "Julio", valor: 7 },
        { nombre: "Agosto", valor: 8 },
        { nombre: "Septiembre", valor: 9 },
        { nombre: "Octubre", valor: 10 },
        { nombre: "Noviembre", valor: 11 },
        { nombre: "Diciembre", valor: 12 }
    ];

    const chartData = useMemo(() => {
        const dataxCategoria = labels.map(label => {
            const registro = registros.find(v => v.categoria === label);

            return registro ? registro.total : 0;
        });

        const colors = [
            "rgba(34, 75, 106, 1)",    // azul oscuro
        ];

        return {
            labels,
            datasets: [
                {
                    label: "Totales por categoría",
                    data: dataxCategoria,
                    backgroundColor: colors[0]
                }
            ]
        }
    }, [registros, labels]);

    const options_barra = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: "top" },
            title: {
                display: true,
                text: 'Emisión documentos'
            }
        }
    }), []);

    useEffect(() => {
        const actual = new Date().getFullYear();
        const mesActual = new Date().getMonth() + 1;

        const nuevosValores = [];

        for (let i = 0; i < 1; i++) {
            nuevosValores.push(actual - 1);
            nuevosValores.push(actual);
            nuevosValores.push(actual + 1);
        }

        setYear(nuevosValores);

        setDataBuscar({ ...dataBuscar, Year: nuevosValores.filter(x => x === actual)[0], Mes: mes.filter(x => x.valor === mesActual)[0].valor });
    }, [])

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    ///Acción para buscar los registros de acuerdo a unos parametros previamente establecidos
    const buscarRegistros = async (event) => {
        event.preventDefault();
        setLoading(true);

        if (dataBuscar.Cliente === undefined && (companyId === 'null' || companyId === null)) {
            alert('Debes seleccionar un cliente');
            setLoading(false);
            return;
        }

        const agrupado = {};

        await getData('api/Cliente/Dashboard/GetReporteClientes', {
            mes: dataBuscar.Mes,
            CompanyId: dataBuscar.Cliente || '',
            year: dataBuscar.Year
        }).then(response => {
            response.resultado.forEach(item => {
                for (const key in item) {
                    if (key !== "Fecha") {
                        if (!agrupado[key]) {
                            agrupado[key] = [];
                        }
                        agrupado[key].push({
                            fecha: item.Fecha,
                            valor: item[key]
                        })
                    }
                }
            })

            const agrupadoCategoria = [];

            for (const categoria in agrupado) {
                let total = 0;

                agrupado[categoria].forEach(item => {
                    total += item.valor;
                });

                agrupadoCategoria.push({
                    categoria: categoria,
                    total: total
                });
            }

            setRegistros(agrupadoCategoria);
            setRegistrosDiarios(response.resultado);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const tablaData = useMemo(() => {
        return registrosDiarios.map((registro) => {
            const fila = { fecha: new Date(registro.Fecha).toLocaleDateString() };

            labels.forEach((cat) => {
                fila[cat] = registro[cat] ?? 0;
            })

            return fila;
        });
    }, [registrosDiarios, labels]);

    const totales = useMemo(() => {
        const resultado = {};

        labels.forEach((cat) => {
            resultado[cat] = registrosDiarios.reduce(
                (acc, curr) => acc + (curr[cat] ?? 0),
                0
            );
        });

        return resultado;

    }, [registrosDiarios, labels]);

    ///Función para descargar un array en excel
    const descargarExcel = () => {
        setLoading(true);
        exportToExcel(tablaData, 'EmisionesDiarias');
        setLoading(false);
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item style={{ fontSize: 14 }} >Home</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>Categorías</Breadcrumb.Item>
        </Breadcrumb>

        {<LoadingComponent Loading={loading} />}

        <Form onSubmit={buscarRegistros}>
            <div className='row'>
                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Mes"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.Mes}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar, Mes: event.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        >
                            {mes.map((item, index) => (
                                <option value={item.valor} key={item.valor}>{item.nombre}</option>
                            ))}
                        </Form.Select>
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Año"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.Year}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar, Year: event.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        >
                            {year.map((item, index) => (
                                <option value={item} key={index}>{item}</option>
                            ))}
                        </Form.Select>
                    </FloatingLabel>
                </div>

                {adminTae === 'true' ?
                    <div className='col-md-5'>
                        <AsyncSelect cacheOptions defaultOptions
                            menuPosition='fixed'
                            noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                            placeholder="Cliente"
                            isClearable={true}
                            loadOptions={companieSearchSelect2}
                            onChange={value => {
                                if (value === null)
                                    setDataBuscar({ ...dataBuscar, Cliente: '' })
                                else
                                    setDataBuscar({ ...dataBuscar, Cliente: value.value })
                            }}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: 50
                                })
                            }}
                        />
                    </div>
                    : null}

                <div className='col-md-1'>
                    <Button variant='primary' type='submit' size="sm">
                        <FaSearch size={'0.8rem'} />
                    </Button>
                </div>

            </div>
        </Form>

        {registros.length > 0 ?
            <Grid container spacing={1} padding={2}>
                <Grid item xs={12} md={6}>
                    <Paper elevation={3} style={{ padding: '20px', height: '100%' }}>
                        <Typography variant="body2">
                            <div style={{ height: "300px" }}>
                                <Bar data={chartData} options={options_barra} />
                            </div>
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 3,
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                bgcolor: "rgba(34, 75, 106, 1)",
                                color: "white",
                                py: 1,
                                px: 2,
                                fontWeight: "bold",
                            }}
                            style={{ textAlign: 'center' }}
                        >
                            Total emitido
                        </Typography>

                        <Table>
                            <TableBody>
                                <TableRow hover>
                                    <TableCell align="center">
                                        {formatNumber(registros.filter(x => x.categoria === 'Facturas')[0].total)}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <br />

                    <Paper elevation={3} style={{ padding: '10px', width: '100%' }}>
                        <table className='table table-borderless table-hover'>
                            <thead>
                                <tr>
                                    <th className="estilo-encabezado2">Categoría</th>
                                    <th className="estilo-encabezado2">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                {registros.filter(x => x.categoria !== 'Facturas').map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: 'center' }}>{item.categoria}</td>
                                        <td style={{ textAlign: 'right' }}>{formatNumber(item.total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Paper elevation={3} style={{ padding: '20px', height: '100%', width: '100%' }}>
                        <div style={{ position: 'relative', textAlign: 'center' }}>
                            <Typography variant="h5" className="text-center">
                                Emisión diaria
                            </Typography>
                            <Button title="Descargar excel" onClick={descargarExcel} style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', backgroundColor: 'gray' }}>
                                <FaFileExcel />
                            </Button>
                        </div>
                        <br />
                        <table className='table table-borderless table-hover'>
                            <thead>
                                <tr>
                                    <th className="estilo-encabezado">Día</th>
                                    {labels.map((item, index) => (
                                        <th className="estilo-encabezado" key={index}>{item}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {tablaData.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: 'center' }}>{item.fecha}</td>
                                        {labels.map((cat) => (
                                            <td style={{ textAlign: 'right' }} key={cat}>
                                                {formatNumber(item[cat])}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td style={{ fontWeight: 'bold', textAlign: 'center' }}>Totales</td>
                                    {labels.map((cat) => (
                                        <td key={cat} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                            {formatNumber(totales[cat])}
                                        </td>
                                    ))}
                                </tr>
                            </tfoot>
                        </table>
                    </Paper>
                </Grid>
            </Grid>
            : null}

    </div>
}

export default EmisionDocumentos;